<template>
    <div id="frame-general" class="container-frame">
        <h1 id="frame-title">Général</h1>
        <div id="container-general">
            <!--COLONE 1-->
            <div class="general-sous-menu" id="general-enregistrement">
                <h3>Enregistrement</h3>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Confirmer si montants différents</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Confirmer toujours la Feuille de soins</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Confirmer toujours la Feuille de soins</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Abandon du patien après enregistrement</label>
                </div>
            </div>
            <div class="general-sous-menu" id="general-barre-outils">
                <h3>Barre d'outils</h3>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Afficher la barre d'outil</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Avec de grandes icônes</label>
                </div>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Avec du texte</label>
                </div>
            </div>
            <div class="general-sous-menu" id="general-ouverture-au-demarrage">
                <h3>Ouverture au démarage</h3>
                <div class="general-group">
                    <input type="radio" name="ouvertureAuDemarage" /><label>Normal</label>
                    <input type="radio" name="ouvertureAuDemarage" /><label>Minimisé</label>
                    <input type="radio" name="ouvertureAuDemarage" /><label>Maximisé</label>
                </div>
            </div>
            <div class="general-sous-menu" id="general-curseur-en-saisie-des-actes">
                <h3>Curseur en saisie des actes</h3>
                <div class="general-group">
                    <input type="checkbox" />
                    <label>Afficher la barre d'outil</label>
                    <label>Forme:</label>
                    <input type="text" maxlength="1" />
                    <label>Forme:</label>
                    <input type="button" value="C" />
                </div>
            </div>
            <!--COLONE 2-->
            <div class="general-sous-menu" id="general-reçu">
                <h3>Reçu</h3>
                <div class="general-group">
                    <input type="radio" name="reçu" /><label>Editer toujours sur traitement texte</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="reçu" /><label>Demander pour édition</label>
                    <input type="radio" name="reçu" /><label>Ne jamais éditer</label>
                </div>
                <div class="general-group">
                    <input type="radio" name="reçu" /><label>Demander pour édition</label>
                </div>
                <div id="general-traitement-de-texte">
                    <h3>Traitement de texte</h3>
                    <div class="general-group">
                        <input type="radio" name="traitementDeTexte" /><label>Utiliser Fisipad</label>
                        <input type="radio" name="traitementDeTexte" /><label>Utiliser le traitement de texte de la machine</label>
                    </div>
                </div>
            </div>
            <div class="general-sous-menu" id="general-couleurs">
                <h3>Couleurs</h3>
                <div class="general-group">
                    <input type="color" name="couleurBordure" /><label>Couleur bordure</label>
                    <input type="color" name="couleurFond" /><label>Couleur fond</label>
                    <input type="color" name="couleurFondlibelles" /><label>Couleur fond libellés</label>
                </div>
                <div>
                    <button>Couleurs par défaut</button>
                </div>
            </div>
            <div id="general-container-btn-selection-par-defaut">
                <div class="general-group">
                    <button>Paramétrage des sélections par défaut</button>
                </div>
            </div>
        </div>
        <div id="frame-footer">
            <button @click="OK()">OK</button>
            <button @click="annuler()">Annuler</button>
            <button @click="appliquer()">Appliquer</button>
        </div>
    </div>
</template>

<style scope>
    @import 'parametre.css';
</style>

<script>
    import { defineComponent } from 'vue';

    export default defineComponent({
        components: {
            //Les composants
        },
        data: function () {
            return {
                message: 'Parametre Général'
            }
        },

        computed: {

        },

        methods: {

        },

        props: {

        },
        mounted() {

        }

        ,
        created() {

        }

    });
</script>